import { render, staticRenderFns } from "./ManifestsTable.vue?vue&type=template&id=5a9b7c3c&scoped=true"
import script from "./ManifestsTable.vue?vue&type=script&lang=js"
export * from "./ManifestsTable.vue?vue&type=script&lang=js"
import style0 from "./ManifestsTable.vue?vue&type=style&index=0&id=5a9b7c3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9b7c3c",
  null
  
)

export default component.exports